export default __webpack_public_path__ + "static/media/julentto-photography-CIuakYIjadc-unsplash.33bbdea6.jpg";